import { AppState } from '@/vuex/store';

export default {
  UPDATE_IS_ALL: (state: AppState, isAll: boolean) => {
    state.upgradeState.isAll = isAll;
  },
  UPDATE_LEVEL: (state: AppState, level: number) => {
    state.upgradeState.level = level;
  },
  UPDATE_TIME: (state: AppState, time: number) => {
    state.upgradeState.time = time;
  },
  UPDATE_FEE: (state: AppState, fee: number) => {
    state.upgradeState.fee = fee;
  },
  UPDATE_PRE_PROMO_FEE: (state: AppState, fee: number) => {
    state.upgradeState.prePromoFee = fee;
  },
  UPDATE_PAY_TYPE: (state: AppState, payType: number) => {
    state.upgradeState.payType = payType;
  },
  UPDATE_MODULES: (state: AppState, modules: string[]) => {
    state.upgradeState.modules = modules;
  },
  UPDATE_DEFAULT_DISCOUNT: (state: AppState, defaultDiscounts: any) => {
    state.upgradeState.discount = defaultDiscounts;
  },
  UPDATE_DISCOUNT: (state: AppState, discount: any) => {
    state.upgradeState.discount = discount;
  },
};
